import React, { useContext } from 'react';
import { store } from '../../../hooks/dataContext';
import { deleteProject } from '../../../utils/projects.api';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

const RemoveNode = (props) => {
  const history = useHistory();
  const { data } = props;
  const globalState = useContext(store);
  const { dispatch } = globalState;

  return (
    <div>
      <p>Are you sure you want to delete this project?</p>
      <p>This cannot be undone.</p>
      <br />
      <Button
        onClick={() => {
          dispatch({
            type: 'TOGGLE_MODAL',
            payload: {
              data: {},
            },
          });
        }}
        type="button"
      >
        <p>No</p>
      </Button>
      <Button
        type="button"
        variant="contained"
        color="primary"
        className="blue white-text"
        onClick={() => {
          deleteProject(data.id, dispatch);
          history.push('/projectlist');
        }}
      >
        <p>Yes I'm sure</p>
      </Button>
    </div>
  );
};

export default RemoveNode;
